import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'

import YouWillAlsoLoveCarousel from 'artkive/components/sections/YouWillAlsoLoveCarousel'

import { alsoLoveStyles } from './KeepsakeAlsoLove.style'

const KeepsakeAlsoLove = ({ slides, classes }) => {
  const keepsakeSlides = useMemo(
    () =>
      slides.map((slide) => ({
        ...slide,
        classes: { content: classes.content, price: classes.price, button: classes.button, lines: classes.lines },
      })),
    [slides, classes],
  )

  return (
    <YouWillAlsoLoveCarousel slides={keepsakeSlides} className={classes.root} classes={{ slides: classes.slides }} />
  )
}

KeepsakeAlsoLove.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(alsoLoveStyles)(KeepsakeAlsoLove)
